import { render, staticRenderFns } from "./FramevrWidget.vue?vue&type=template&id=0d9b9dea"
import script from "./FramevrWidget.vue?vue&type=script&lang=js"
export * from "./FramevrWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports